import { useEffect, useState } from "react";

import { useQueryClient } from "@tanstack/react-query";

import useJobMutations from "../../../data/useJobMutations";
import useDefaultCRUDHandlers from "../../../hooks/useDefaultCRUDHandlers";
import useStockPermissions from "../../../data/useStockPermissions";
import { IJob } from "../../../models/Job";
import { ILead } from "../../../models/Lead";
import openInNewTab from "../../../utils/openInNewTab";
import Card from "../../shared/Card/Card";
import ConfirmModal from "../../shared/Confirm/ConfirmModal";
import { ButtonInput } from "../../shared/Inputs/ButtonInput";


export default function LeadJobs({ lead }: { lead: ILead }) {
  const queryClient = useQueryClient();
  const { remove } = useJobMutations();
  const { deleteHandlers } = useDefaultCRUDHandlers("Job");
  const { restricted } = useStockPermissions();
  const [deleteJob, setDeleteJob] = useState<IJob | null>(null);
  const [deleteOpen, setDeleteOpen] = useState<boolean>(false);
  const [deleteLoading, setDeleteLoading] = useState<boolean>(false);

  const handleDeleteJob = () => {
    setDeleteLoading(true);
    if (deleteJob) {
      remove.mutate(deleteJob, {
        onSuccess: () => {
          queryClient.invalidateQueries(["lead", lead.id]);
          queryClient.invalidateQueries(["vehicles", lead.vehicleId]);
          setDeleteOpen(false);
          deleteHandlers.onSuccess();
        },
        onError: deleteHandlers.onError,
        onSettled: () => {
          setDeleteLoading(false);
        },
      });
    } else {
      deleteHandlers.onError();
      setDeleteLoading(false);
    }
  };

  useEffect(() => {

  }, [lead.jobs]);

  return (
    <>
      <ConfirmModal
        open={deleteOpen}
        setOpen={setDeleteOpen}
        title={"Delete job?"}
        message={`Are you sure you want to remove this job?\n It will no longer appear on the job calendar.`}
        confirmButtonText={"Delete"}
        onConfirm={handleDeleteJob}
        isLoading={deleteLoading}
      />
      <Card title="Lead Jobs" bodyClassName="p-4" collapsible>
        <div className="flex flex-col justify-evenly gap-y-2">
          {lead.jobs?.map((job) => (
            <div
              key={job.id}
              className="flex justify-between border-b-2 last:border-b-0 pb-2"
            >
              <div className="flex flex-col gap-y-2">
                <h1 className="text-lg font-semibold">
                  {job.title.replace(/-[^-]*$/, "")} - {job.duration} mins
                </h1>
                <p>{job.description}</p>
              </div>
              <div className="flex gap-x-2 items-center">
                <ButtonInput
                  label={"View"}
                  isSubmit={false}
                  onClick={() => openInNewTab(`/jobs/${job.id}`)}
                  classes={""}
                />
                {/* Stock:AdminOnlyChanges - deleting is admin-only, matching the API */}
                {!restricted && (
                  <ButtonInput
                    label={"Delete Job"}
                    isSubmit={false}
                    onClick={() => {
                      setDeleteOpen(true);
                      setDeleteJob(job);
                    }}
                    classes={"!bg-red-500 hover:!bg-red-700"}
                  />
                )}
              </div>
            </div>
          ))}
        </div>
      </Card>
    </>
  );
};